import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography, Paper } from '@mui/material';
import { ScreenFrame } from '../PrototypeShared';

export default function ProcessViewerScreen() {
  return (
    <ScreenFrame
      title="Processes"
      actions={<Button component={Link} to="/prototype/dashboard" variant="outlined" size="small">Dashboard</Button>}
    >
      <Typography color="text.secondary" paragraph>BPMN process viewer. Links to related screens.</Typography>
      <Paper sx={{ p: 2 }}>
        <Button component={Link} to="/prototype/audits" sx={{ mr: 1 }}>Audit process</Button>
        <Button component={Link} to="/prototype/incoming-deliveries">Inbound process</Button>
      </Paper>
    </ScreenFrame>
  );
}
